import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Container, Form, Button, Tabs, Tab } from "react-bootstrap";
import { getCodeAudit, setShowCodeAudit, getCodeStandard, getUploadStandard } from "../../state/reducers/codeAudit";
import { getCodeSpecification, setShowSpecification, setShowOverview } from "../../state/reducers/CodeSpecification";
import { getGraph, getCodeOverview } from "../../state/reducers/codeOverview";
import { getSecurityValidator } from "../../state/reducers/securityValidator";
import { getUnitTest, setShowUnitTest } from "../../state/reducers/unitTest";
import { updateLoadingMessage } from "../../state/reducers/common";
import loadingMessages from "../../common/loadingMessages";
import ReactMarkdown from "react-markdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Select from "../../common-components/select/Select.jsx";
import { modelOptions } from "../CodeConversion/conversion-options";
import InputField from "../../common-components/input-field/Input-field.jsx";

const CloneRepo = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [guidelineOption, setGuidelineOption] = useState("upload");
  const [selectedStandard, setSelectedStandard] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState("");
  const [repoPath, setRepoUrl] = useState("");
  const [language, setlanguage] = useState("");
  const [guideline, setGuideline] = useState("");
  const [model, setModel] = useState("");
  const guidelineContent = useSelector((state) => state.codeAudit.guidelineContent)

  const inputChange = (event) => {
    setRepoUrl(event.target.value);
  };

  const languageChange = (event) => {
    setlanguage(event.target.value);
  };
  
  const isCodeDocumentationPath = location.pathname === "/code-documentation";
  const isCodeSpecificationPath = location.pathname === "/code-specification";
  const isUnitTestPath = location.pathname === "/unit-test";
  const isCodeGenerationPath = location.pathname === "/data-generation";
  const isCodeAuditPath = location.pathname === "/code-audit";
  const isCodeOverviewPath = location.pathname === "/code-overview";
  const isSecurityValidator = location.pathname === "/security-validator";
  const isBusinessRequirements = location.pathname === "/business-requirements";
  const isDataGeneration = location.pathname === "/data-generation";
  const isCodeImpactAnalysis = location.pathname === "/code-impact-analysis";
  const isCodeRefactoring = location.pathname === "/code-refactoring";
  const isVersionBasedConversion = location.pathname === "/version-based-conversion";
  const isTargetArchitectureBasedConversion = location.pathname === "/target-architecture-based-conversion";
  const isETLMapping = location.pathname === "/ETL-mapping";

  const handleGuidelineOptionChange = (event) => {
    setGuidelineOption(event.target.value);
  };
  

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();

      reader.onload = function(e) {
        const content = {
          name: file.name,
          content: e.target.result
        };
        setFileContent(content)
      };

      reader.readAsText(file);
    }
  };

  const handleViewCodeAudit = async () => {
    try {
      // let guidelineContent = "";
  
      // Handle the guideline submission
      if (guidelineOption === "upload" && selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        dispatch(updateLoadingMessage({
          message: loadingMessages.common
        }))
        const result = await dispatch(getUploadStandard(formData));
        setGuideline(result.payload.file_content);
      }
  
      // Proceed with the code audit only if guidelineContent is available
      if (guideline) {
        const payload = {
          repoURL: repoPath,
          guidelineContent: guideline,
          selected_model: model
        };
        dispatch(updateLoadingMessage({
          message: loadingMessages.common
        }))
        const result = await dispatch(getCodeAudit(payload));
        console.log("Code Audit Response:", result);  // Log the response
        
        dispatch(setShowCodeAudit(true));
      } else {
        console.error("No guideline content available");
      }
    } catch (error) {
      console.error("Error in handleCodeAudit:", error);
    }
  };

  const handleViewSpecification = () => {
    dispatch(updateLoadingMessage({
      message: loadingMessages.common
    }))
    dispatch(getCodeSpecification({repoPath: repoPath, selected_model: model }));
    dispatch(setShowSpecification(true));
    dispatch(setShowOverview(false));
  };

  const handleViewSecurityValidator = () => {
    dispatch(updateLoadingMessage({
      message: loadingMessages.common
    }))
    dispatch(getSecurityValidator({ repo_url: repoPath, selected_model: model }));
    // dispatch(setShowValidator(true));
    // dispatch(setShowOverview(false));
  };

  const handleViewUnitTest = () => {
    dispatch(updateLoadingMessage({
      message: loadingMessages.common
    }))
    dispatch(
      getUnitTest({repoPath: repoPath, language: language, selected_model: model}),
      setShowUnitTest(true),
      setShowOverview(false)
    )
  }

  const handleCloseGuideline = () => {
    setFileContent("");
    setSelectedFile(null);
    setGuideline("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleViewBusinessRequirements = () => {
    dispatch(updateLoadingMessage({
      message: loadingMessages.common
    }))
    console.log("Premium Feature : Business Requirements")
  };

  const handleViewisCodeDocumentationPath = () => {
    dispatch(updateLoadingMessage({
      message: loadingMessages.common
    }))
    console.log("Premium Feature : Code Documentation")
  };

  

  let pageTitle;
  if (isCodeAuditPath) {
    pageTitle = "Code Audit";
  } else if (isUnitTestPath) {
    pageTitle = "Unit Test";
  } else if (isCodeDocumentationPath) {
    pageTitle = "Code Documentation";
  } else if (isCodeSpecificationPath) {
    pageTitle = "Code Specification";
  } else if (isCodeGenerationPath) {
    pageTitle = "Code Generation";
  } else if (isCodeOverviewPath){
    pageTitle = "Code Overview";
  } else if (isSecurityValidator){
    pageTitle = "Security Validator";    
  } else if (isBusinessRequirements){
    pageTitle = "Business Requirements";
  } else if (isDataGeneration){
    pageTitle = "Data Generation";
  } else if (isCodeImpactAnalysis){
    pageTitle = "Code Impact Analysis";
  } else if (isCodeRefactoring){
    pageTitle = "Code Refactoring";
  } else if (isVersionBasedConversion){
    pageTitle = "Version Based Conversion";
  } else if (isTargetArchitectureBasedConversion){
    pageTitle = "Target Architecture BasedConversion";
  } else if (isETLMapping){
    pageTitle = "ETL Mapping";
  } else {
    pageTitle = "Clone Repo";
  }
  console.log("Guideline: ", guidelineContent)
  return (
    <div className="page-wrapper code-overview-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">{pageTitle}</h2>
              <div className="clone-wrapper">
                <div className="clone-form">
                  <Form>
                    <Row>
                      {/* <Col md="3">
                        <Form.Label htmlFor="inputRepoUrl">Enter Github Repository Url</Form.Label>
                      </Col> */}
                      <Col md={6}>
                        <InputField 
                          id="github-link" 
                          label="GitHub Url"
                          value={repoPath} 
                          onChange={inputChange}
                          layoutStyle="horizontal"
                          labelColSize={4}
                          inputColSize={8}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <Select 
                          value={model} 
                          options={modelOptions} 
                          placeholder={"Select Model"} 
                          label="Model" 
                          id="model" 
                          onChange={(e) => setModel(e.target.value)}
                          layoutStyle="horizontal"
                          labelColSize={4}
                          inputColSize={8} 
                          required
                        />
                      </Col>
                    </Row>
                    {isCodeAuditPath && (
                      <>
                        <Row className="mt-4">
                          <Col md="4">
                            <Form.Check 
                              type="radio" 
                              label="Upload Code Guideline" 
                              value="upload" 
                              className="input-radio"
                              checked={guidelineOption === "upload"} 
                              onChange={handleGuidelineOptionChange} 
                            />
                          </Col>
                          <Col md="4">
                            <Form.Check 
                              type="radio" 
                              label="Select Code Guideline" 
                              value="select" 
                              className="input-radio"
                              checked={guidelineOption === "select"} 
                              onChange={handleGuidelineOptionChange} 
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            {guidelineOption === "upload" && (
                              <>
                                <Form.Control 
                                  type="file"
                                  className="mt-3" 
                                  onChange={handleFileChange}
                                  ref={fileInputRef}
                                />
                                {fileContent &&
                                  <Tabs
                                    defaultActiveKey={fileContent.name}
                                    id="uncontrolled-tab-example"
                                    className="source-code-wrapper mt-4"
                                  >
                                    <Tab eventKey={fileContent.name} title={<div className="d-flex align-items-center">
                                      <span>{fileContent.name}</span>
                                      <Button 
                                        variant="link" 
                                        className="p-0 ms-2 close-btn" 
                                        onClick={handleCloseGuideline}
                                      >
                                        <FontAwesomeIcon icon={faXmark} />
                                      </Button>
                                    </div>
                                    }>
                                      <div className="tab-content-wrapper">
                                        <ReactMarkdown>{fileContent.content}</ReactMarkdown>
                                      </div>
                                    </Tab>
                                  </Tabs>}
                              </>
                            )}
                            {guidelineOption === "select" && (
                              <>
                                <Form.Select 
                                  className="mt-3"
                                  onChange={async (e) => {
                                    setSelectedStandard(e.target.value)
                                    dispatch(updateLoadingMessage({
                                      message: loadingMessages.common
                                    }))
                                    const result = await dispatch(getCodeStandard(e.target.value));
                                    setGuideline(result.payload.details);
                                  }}
                                  value={selectedStandard}
                                >
                                  <option value="">Select Guideline Type</option>
                                  <option value="google_standard_pyspark">Google Standard</option>
                                </Form.Select>
                                {guidelineContent &&
                                  <Tabs
                                    defaultActiveKey={"Guideline"}
                                    id="uncontrolled-tab-example"
                                    className="source-code-wrapper mt-4"
                                  >
                                    <Tab eventKey={"Guideline"} title={<div className="d-flex align-items-center">
                                      Guideline
                                    </div>
                                    }>
                                      <div className="tab-content-wrapper">
                                        <ReactMarkdown>{guidelineContent}</ReactMarkdown>
                                      </div>
                                    </Tab>
                                  </Tabs>}
                              </>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewCodeAudit}>
                              Code Audit
                            </Button>
                          </Col>
                        </Row>  
                        
                      </>
                    )}
                    {isCodeSpecificationPath && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewSpecification}>
                              Code Specification
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isCodeOverviewPath && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn me-3" onClick={() => dispatch(getGraph({
                              repoPath: repoPath,
                              selected_model: model
                            }))}>
                              Visualize Code Structure
                            </Button>
                            <Button className="blue-btn" onClick={() => dispatch(getCodeOverview({
                              repoPath: repoPath,
                              selected_model: model
                            }))}>
                          Show Overview
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isSecurityValidator && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewSecurityValidator}>
                            Security Validator
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isBusinessRequirements && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Business Requirements
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isDataGeneration && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Data Generation
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isCodeImpactAnalysis && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Code Impact Analysis
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isCodeRefactoring && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Code Refactoring
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isVersionBasedConversion && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Version Based Conversion
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isTargetArchitectureBasedConversion && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            Target Architecture Based Conversion
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isETLMapping && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewBusinessRequirements}>
                            ETL Mapping
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isCodeDocumentationPath && (
                      <>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewisCodeDocumentationPath}>
                            Code Documentation
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                    {isUnitTestPath && (
                      <>
                        <Row>
                          <Col md="6">
                            <Row className="mt-3">
                              <Col md="4">
                                <Form.Label htmlFor="inputRepoUrl">Language</Form.Label>
                              </Col>
                              <Col md="8">
                                <Form.Control
                                  type="input"
                                  id="inputLanguage"
                                  placeholder="Enter language" 
                                  className="repo-url"
                                  value={language}
                                  onChange={languageChange}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col className="text-end">
                            <Button className="blue-btn ms-3" onClick={handleViewUnitTest}>
                              Unit Test
                            </Button>
                          </Col>
                        </Row> 
                      </>
                    )}
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CloneRepo;